import Grid from "@mui/material/Grid";
import { Outlet } from "react-router-dom";
import Navbar from "./modules/shared/components/Navbar";
import Topbar from "./modules/shared/components/Topbar";
import { OrderProvider } from "./contexts/OrderContext";
import NavbarDesktop from "./modules/shared/components/Navbar/NavbarDesktop";
import { useTheme, useMediaQuery, Drawer, Box } from "@mui/material";
import { useState } from "react";

export default function App() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [drawerOpen, setDrawerOpen] = useState(() => {
    const savedDrawerState = localStorage.getItem("drawerOpen");
    return savedDrawerState === "true";
  });

  return (
    <OrderProvider>
      {drawerOpen && (
        <Drawer variant={"permanent"} anchor="left">
          <NavbarDesktop />
        </Drawer>
      )}

      <Box
        sx={{
          flexGrow: 1,
          marginLeft: isDesktop ? (drawerOpen ? 30 : 0) : 0,
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: 400,
          }),
          background: "#f4f7f9",
          minHeight: "100vh",
        }}
      >
        <Topbar setDrawerOpen={setDrawerOpen} drawerOpen={drawerOpen} />
        <Grid
          container
          sx={{
            background: "#f4f7f9",
            minHeight: "100vh",
          }}
        >
          <Outlet />
        </Grid>
      </Box>
      <Navbar />
    </OrderProvider>
  );
}
